export enum ClientTimelineItemType {
  Memo = 1,
  OfferChange = 2,
  ClientChange = 3
}

(ClientTimelineItemType as any).__typeName = 'ClientTimelineItemType';
